module.exports = __webpack_public_path__ + "img/logo-bandera.42e8071b.svg";